export class FavoriteItem {
    sportId!: string
    eventId!: string

    constructor(favoritePair: string = "") {
        let pairs = favoritePair.split(";");
        if (pairs.length === 2) {
            this.setValues(pairs[0], pairs[1]);
        }
    }

    setValues(sportId: string, eventId: string) {
        this.sportId = sportId;
        this.eventId = eventId;
    }

    stringify(): string {
        return this.sportId && this.eventId ? `${this.sportId};${this.eventId}` : "";
    }
}